import {
  type LocalAccount,
  useLocalAccountForSession,
  useRecordAccountEmailForSession,
} from "#use-local-account-for-session";
import { useAuthSession } from "#use-auth-session";

/**
 * This device's local account, or `null` when it has none. Synchronous on native (the session is
 * primed from its cache before the first render, and the rest is MMKV), so startup can route on it.
 */
export function useLocalAccount(): LocalAccount | null {
  return useLocalAccountForSession(useAuthSession());
}

/**
 * Keeps `accountEmail` equal to the signed-in session's address, so the account keeps its email
 * after the session expires and follows an address changed on the server. Mounted by the native
 * app gate; auth forms that leave before the session is published record the typed address
 * themselves.
 */
export function useRecordSessionAccountEmail(): void {
  useRecordAccountEmailForSession(useAuthSession());
}
